import script from "./FooterView.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=200d9a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200d9a4e"]])

export default __exports__